import { useEffect, useState, useRef } from 'react';
import './App.css';

const fullText = `
Sé que seguramente estarás flipando ahora mismo pensando: este tío está loco, pero lo siento, te ha tocado uno así, un loquillo sentimental que, si está a gusto con esa persona, le encanta escribir cómo se siente y transmitírselo. Dicho esto, sí que es verdad que el mini texto de fin de año no lo tenía planeado, ya que fue la noche anterior que me salió escribirlo y ahora puede ser que haya algo que quede repetitivo, pero bueno, ahí va.

El preludio (como a ti te gusta esta palabra jeje), qué vaya sitio, un hospital, con las condiciones que estábamos, tanto tú sobre todo físicamente (por lo que sea), como con el cansancio que teníamos después de dormir poco y la noche anterior estar en máximos. Y con todo esto, aun así, me encantó conocerte y me pareciste una chica súper interesante y que tenía unas ganas increíbles de seguir conociendo. Porque de verdad que no sabría cómo expresarte la felicidad que sentí al llegar a la resi después de estar todo ese rato contigo en el hospital y recapacitar sobre todo lo que había pasado.

Al cabo de unos días, me animé a decirte de ir a cenar, aunque por dentro estaba muerto de la vergüenza, pero qué contento estoy de cómo fue la cena y el posterior paseíto y todo. Aunque, como los dos sabemos, ese día en la domeq tampoco fue muy bien el asunto sexual. Por eso también quiero aprovechar por decirte gracias, porque después de cómo fueron nuestras primeras dos veces, que entre mis nervios, alcohol y todo fueron mal, y aun así con todo siempre me he sentido súper arropado y tranquilizado por tu parte. Que es como un miedo que tenía de joder la primera vez, seguro que la cago y mil pensamientos así, y tú desde un principio hiciste que en ningún momento me pudiese sentir mal, sino todo lo contrario.

Después de ese día de la cena y todo fue cuando pensé de verdad que quería seguir conociéndote más en serio, porque me parecías una chica súper válida, en el sentido de trabajadora, estudiante, cariñosa, súper divertida, competente, inteligente, empática en todo momento conmigo y mil cosas más que podría decirte.

Avanzando ya más en el tiempo, por fin llegó el día que marcó un antes y un después, que gracias a tu paciencia, que ya ganamos confianza y el estilo acogedor de la Komárov, llegó el día donde todo salió bien y de verdad fue un gran polvo. Que esto, aunque parezca una tontería, a mí me tenía algo rallado, por cómo te podrías estar sintiendo tú y que en algún momento te pudieses sentir agobiada o mal. Y ya después de esto, todo noviembre fue increíble pasando tardes, noches y mil ratos contigo y conociéndote bien.

Y llegando al final de este gran noviembre, no podría haber mejor forma de terminarlo que irme contigo de viaje y encima a Viena, que por Navidad es preciosa (como nosotros 😊). Que lo miras desde fuera y es una poca locura irte de viaje con alguien que llevábamos un mes y poco hablando y quedando. Quién diría, por eso, que aun sin conocernos tanto encajaríamos tan bien en el estilo de viajar y de verdad que, por ser un viaje así de improvisao, salió todo perfecto y por mi parte no lo pude pasar mejor ni ser más feliz en esas 48 horas juntos.

Y ya para terminar este resumen del tiempo, decirte que en diciembre fue donde me terminaste de ganar del todo, si es que no me tenías ya, con esa tarde-noche en el apartamento de Brno, porque ahí sentí de verdad lo que es que el tiempo pasa volando, porque en mi caso aún no lo había experimentado y de verdad que esas horas tumbado contigo en la cama me pasaron como segundos de lo cómodo y feliz que estoy contigo. Y ya con el gesto que tuviste conmigo al día siguiente viniendo a patinar sabiendo que Laura no iba a venir, pero como viste que a mí me hacía ilusión, simplemente por el hecho de hacerme feliz viniste y me encantó y lo pasé genial.

Con el resumen cronológico ya terminado, quiero decirte que estos ya más de dos meses hablando y viéndonos, para mí (aunque sé que pueda quedar bastante fuerte), han estado perfectamente de los meses más felices de mi vida, por eso siempre te estaré agradecido y, como ya te dije el otro día, ya formas parte de mi historia, por ser mi primera vez en muchas cosas, y bien feliz que estoy de que hayas sido tú y que contigo esté aprendiendo tantas cosas y también descubriendo emociones y sentimientos por primera vez.

Dicho esto, sé que tenemos que tener esa charla sobre la distancia, pero de verdad que yo quiero hacer todo lo posible para que esto sea simplemente el primer capítulo de la historia. Porque de verdad siento que he encajado súper bien contigo y me pareces una chica increíble, y que en todo momento nos hemos entendido súper bien en todo y por eso también estoy seguro de que nos entenderemos y nos pondremos de acuerdo en cómo lo vamos a gestionar.

Esto, por ejemplo, que aunque para ti pueda ser una tontería, pero que desde el primer día ya te interesaste en aprender catalán ya me dijo mucho de cómo eres como persona y que de verdad fue una forma de demostrarme el interés.
`;

function Countdown() {
    const [timeLeft, setTimeLeft] = useState({});

    useEffect(() => {
        const target = new Date('2026-11-08T08:30:00');

        const calc = () => {
            const now = new Date();
            const diff = target - now;

            if (diff <= 0) {
                setTimeLeft({ arrived: true });
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            setTimeLeft({ days, hours, minutes, seconds });
        };

        calc();
        const interval = setInterval(calc, 1000);
        return () => clearInterval(interval);
    }, []);

    if (timeLeft.arrived) {
        return (
            <div className="countdown">
                <p className="countdown-title">¡Por fin juntos! 🥰</p>
            </div>
        );
    }

    return (
        <div className="countdown">
            <p className="countdown-title">Falta para vernos...</p>
            <div className="countdown-boxes">
                <div className="countdown-box">
                    <span className="countdown-number">{timeLeft.days}</span>
                    <span className="countdown-label">días</span>
                </div>
                <div className="countdown-box">
                    <span className="countdown-number">{timeLeft.hours}</span>
                    <span className="countdown-label">horas</span>
                </div>
                <div className="countdown-box">
                    <span className="countdown-number">{timeLeft.minutes}</span>
                    <span className="countdown-label">min</span>
                </div>
                <div className="countdown-box">
                    <span className="countdown-number">{timeLeft.seconds}</span>
                    <span className="countdown-label">seg</span>
                </div>
            </div>
        </div>
    );
}

function App() {
    const hasSeen = localStorage.getItem('hasSeenLetter');

    const [text, setText] = useState(hasSeen ? fullText : '');
    const [index, setIndex] = useState(hasSeen ? fullText.length : 0);

    const bottomRef = useRef(null);

    useEffect(() => {
        if (index < fullText.length) {
            const timeout = setTimeout(() => {
                setText(prev => prev + fullText[index]);
                setIndex(index + 1);
            }, 55);
            return () => clearTimeout(timeout);
        } else {
            localStorage.setItem('hasSeenLetter', 'true');
        }
    }, [index]);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [text]);

    return (
        <div className="App">
            <header className="App-header">
                <Countdown />
                <img src="/fondo.png" alt="Nosotros" className="photo" />
                <p className="signature">Arnau❤️</p>
            </header>
            <div ref={bottomRef} />
        </div>
    );
}

export default App;
